import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  queryKey?: string;
  idCampanha?: string;
}
export function useGetResumoDoDia(props: Props) {
  const fetchData = async () => {
    const hasIdCampanha = props.idCampanha
      ? `?idCampanha=${props.idCampanha}`
      : "";
    const LISTAR_DESTAQUES = `${leadsWebEnviroment}/common/campanha/buscar-indicadores-resumo-dia/v1${hasIdCampanha}`;
    const response = await instance.get(LISTAR_DESTAQUES);
    return response?.data?.data;
  };

  const query = useQuery({
    enabled: true,
    queryFn: fetchData,
    queryKey: [props.queryKey || "resumo_do_dia"],
    refetchOnWindowFocus: false,
  });

  return query;
}
